module.exports = __webpack_public_path__ + "static/remember_the_milk_2-3ba981bab999e5a1b1097f6980575d00.png";